import './App.css';
import { ChakraProvider } from '@chakra-ui/react';
import { Navigate, Route, Routes } from "react-router-dom"
import { ACTIVITIES } from './Components/info_all_activities';

import Footer from './Components/Footer';
import NavBar from './Components/NavBar';

import HomePage from './Pages/HomePage';
import Organization from './Pages/Organization';
import Chief from './Pages/Chief';
import Research from './Pages/Research';
import Report from './Pages/Report';

import FinTech from './Fintech/finTech';
import FinBuss from './FinBuss/finBuss';
import FinLaw from './FinLaw/finLaw';
import Industry from './Industry/industry';

import AdvisoryCommittee from './AdvisoryCommittee/advisorycommittee';

import Activity from './Pages/Activity';
import Event from './Activities/event';

import PersonalPage from './Pages/PersonalPage';
import Contact from './Pages/Contact';
import InterviewList from './Interviews/InterviewList';
import InterviewDetail from './Interviews/InterviewDetail';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <ChakraProvider>
      <LanguageProvider>
        <div className="App">
          <NavBar />
          <main className="main-content">
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/organization" element={<Organization />} />
            <Route path="/chief" element={<Chief />} />
            <Route path="/research" element={<Research />} />
            <Route path="/report" element={<Report />} />

            <Route path="/finTech" element={<FinTech />} />
            <Route path="/finBuss" element={<FinBuss />} />
            <Route path="/finLaw" element={<FinLaw />} />
            <Route path="/industry" element={<Industry />} />

            <Route path="/advisory" element={<AdvisoryCommittee />} />

            <Route path="/activity" element={<Activity />} />
            <Route path="/news" element={<Navigate to="/activity" replace />} />
            {ACTIVITIES.map((v, i)=>{
              return <Route key={i} path={`/activity/${i}`} element={<Event id={i} />} />
            })}

            <Route path="/interview" element={<InterviewList />} />
            <Route path="/interview/:id" element={<InterviewDetail />} />

            <Route path="/personalPage" element={<PersonalPage />} />
            <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </LanguageProvider>
    </ChakraProvider>
  );
}

export default App;
